import { render, staticRenderFns } from "./page-button.vue?vue&type=template&id=2f0724b6&scoped=true&"
import script from "./page-button.vue?vue&type=script&lang=js&"
export * from "./page-button.vue?vue&type=script&lang=js&"
import style0 from "./page-button.vue?vue&type=style&index=0&id=2f0724b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0724b6",
  null
  
)

export default component.exports